import React from 'react';
import { useLoading } from '../../contexts/LoadingContext';

const NavigationLoader = () => {
  const { isAnyLoading } = useLoading();

  if (!isAnyLoading()) return null;

  return (
    <>
      {/* Top loading bar */}
      <div className="fixed top-0 left-0 right-0 z-50 h-1 bg-slate-800">
        <div className="h-full bg-gradient-to-r from-indigo-500 to-purple-500 animate-pulse">
          <div className="h-full bg-gradient-to-r from-indigo-400 to-purple-400 animate-loading-bar origin-left"></div>
        </div>
      </div>
      
      {/* Backdrop overlay */}
      <div className="fixed inset-0 bg-slate-900/20 backdrop-blur-[1px] z-40 pointer-events-none transition-opacity duration-300" />
    </>
  );
};

export default NavigationLoader;